import React from 'react'
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import {useStyles} from './styles'
import { Typography } from '@material-ui/core';
import './styles.css'

const CustomTimelineItem = ({title, description}) => {
    const classes = useStyles();
    return (
      
        <TimelineItem>
        <TimelineSeparator className={classes.separator_padding}>
        
          <TimelineDot variant='outlined' className={classes.timeline_dot} />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent >
        <Typography gutterBottom variant="h6" component="h2" className={classes.timeline_header}>
              {title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
              {description}
          </Typography>
        </TimelineContent>
        
      </TimelineItem>
      
     
    )
}

export default CustomTimelineItem

